export default defineNuxtPlugin(async () => {
  try {
    const appStore = useAppStore();
    const versionRepo = (await import('repository/version')).default as {
      getVersion: () => Promise<any>;
    };

    const resp = await versionRepo.getVersion();

    // Aceita string direta, objeto com campo 'versao' ou array com estes formatos
    const pick = (v: any): string | undefined =>
      typeof v === 'string' ? v : v && typeof v.versao === 'string' ? v.versao : undefined;

    const resolved = Array.isArray(resp) ? pick(resp[0]) : pick(resp);

    if (resolved) {
      appStore.setVersion(resolved);
    }
  } catch (err) {
    // Silencia falhas de versão; mantém a de fallback do runtimeConfig
    console.warn('[version.plugin] Falha ao obter versão da API');
  }
});
